
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RewardManageDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Reward"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customMessageLabel"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"customMessageRequired"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"internalCost"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"availableStock"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalStock"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"availableFrom"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"availableUntil"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":165}};
    doc.loc.source = {"body":"fragment RewardManageDetails on Reward {\n  customMessageLabel\n  customMessageRequired\n  internalCost\n  availableStock\n  totalStock\n  availableFrom\n  availableUntil\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    



//////////////////
// WEBPACK FOOTER
// ./src/graphql/fragments/RewardManageDetails.gql
// module id = aVFM
// module chunks = 40